import script from "./EventsFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsFilter.vue?vue&type=script&setup=true&lang=js"

import "./EventsFilter.vue?vue&type=style&index=0&id=651921c2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-651921c2"]])

export default __exports__